import styled, { css } from "styled-components";

export const VIDEO_CONTAINER_STYLES = { width: "unset", height: "unset", position: "unset", paddingTop: "unset", overflow: "unset" };

export const CameraQRReaderRoot = styled.div(
    ({ theme }) => css`
        height: 23.625rem;
        width: 100%;
        position: relative;
        background-color: ${theme.palette.overlays["350"]["20"]};
        &,
        video {
            border-radius: ${theme.borderRadiusXl};
        }
        section > div {
            width: unset;
        }
    `,
);
